var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      title: _vm.$t(
        "label_essweb_leaveBalance_form_dialog_viewLeaveTransactionTitle"
      ),
      dialog: _vm.show,
      width: "800",
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_leaveBalance_form_dialog_leaveTypeLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-select", {
                          attrs: {
                            items: _vm.leaveType,
                            readonly: !_vm.isEdited,
                            filled: false,
                            "append-icon": "",
                            "item-text": "leave_type_name",
                            "item-value": "uuid",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            dense: "",
                            placeholder: _vm.$t(
                              "label_essweb_leaveBalance_form_dialog_leaveTypeLabel"
                            ),
                            "single-line": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.TransactionsData.leave_type_uuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.TransactionsData,
                                "leave_type_uuid",
                                $$v
                              )
                            },
                            expression: "TransactionsData.leave_type_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_leaveBalance_form_dialog_transactionTypeLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-select", {
                          attrs: {
                            readonly: !_vm.isEdited,
                            filled: false,
                            items: _vm.Transactiontype,
                            disabled: !_vm.TransactionsData.leave_type_uuid,
                            "item-text": "leave_transaction_type_name",
                            "item-value": "uuid",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            "append-icon": "",
                            dense: "",
                            placeholder: _vm.$t(
                              "label_essweb_leaveBalance_form_dialog_transactionTypeLabel"
                            ),
                            "single-line": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value:
                              _vm.TransactionsData.leave_transaction_type_uuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.TransactionsData,
                                "leave_transaction_type_uuid",
                                $$v
                              )
                            },
                            expression:
                              "TransactionsData.leave_transaction_type_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.logic_method == "D"
                      ? [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xs: "12",
                                sm: "6",
                                md: "6",
                                lg: "6",
                                cols: "12",
                              },
                            },
                            [
                              _c("DateTimePicker", {
                                attrs: {
                                  type: "datetime",
                                  readonly: !_vm.isEdited,
                                  filled: false,
                                  defaultTime:
                                    _vm.TransactionsData.start_utc_datetime,
                                  max: _vm.TransactionsData.end_utc_datetime,
                                  rules: _vm.$GetRules(
                                    ["_Require_Rules"],
                                    [null]
                                  ),
                                  label: _vm.$t(
                                    "label_essweb_leaveBalance_form_dialog_leaveStartTimeLabel"
                                  ),
                                },
                                on: {
                                  change: function (time) {
                                    return (_vm.TransactionsData.start_utc_datetime =
                                      time)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xs: "12",
                                sm: "6",
                                md: "6",
                                lg: "6",
                                cols: "12",
                              },
                            },
                            [
                              _c("DateTimePicker", {
                                attrs: {
                                  type: "datetime",
                                  readonly: !_vm.isEdited,
                                  filled: false,
                                  defaultTime:
                                    _vm.TransactionsData.end_utc_datetime,
                                  min: _vm.TransactionsData.start_utc_datetime,
                                  rules: _vm.$GetRules(
                                    ["_Require_Rules"],
                                    [null]
                                  ),
                                  label: _vm.$t(
                                    "label_essweb_leaveBalance_form_dialog_leaveEndTimeLabel"
                                  ),
                                },
                                on: {
                                  change: function (time) {
                                    return (_vm.TransactionsData.end_utc_datetime =
                                      time)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                    Number(_vm.clientMode) == 1
                      ? _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "12",
                              md: "12",
                              lg: "12",
                              cols: "12",
                            },
                          },
                          [
                            _c("DateTimePicker", {
                              attrs: {
                                type: "month",
                                readonly: !_vm.isEdited,
                                filled: false,
                                defaultTime: _vm.TransactionsData.leave_period,
                                rules: _vm.$GetRules(
                                  ["_Require_Rules"],
                                  [null]
                                ),
                                label: _vm.$t(
                                  "label_essweb_leaveBalance_form_dialog_leavePeriodLabel"
                                ),
                              },
                              on: {
                                change: function (time) {
                                  return (_vm.TransactionsData.leave_period =
                                    time)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_leaveBalance_form_dialog_totalDayHourLabel"
                              )
                            )
                          ),
                        ]),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { md: "5" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    dense: "",
                                    "single-line": "",
                                    type: "number",
                                    readonly: !_vm.isEdited,
                                    filled: false,
                                    placeholder: "days",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "append-outer",
                                      fn: function () {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-subtitle-1 text-center",
                                              staticStyle: { width: "40px" },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "label_essweb_system_dayLabel"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                  model: {
                                    value: _vm.TransactionsData.number_of_day,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.TransactionsData,
                                        "number_of_day",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "TransactionsData.number_of_day",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { md: "5" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    dense: "",
                                    type: "number",
                                    "single-line": "",
                                    readonly: !_vm.isEdited,
                                    filled: false,
                                    placeholder: "hours",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "append-outer",
                                      fn: function () {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-subtitle-1 text-center",
                                              staticStyle: { width: "40px" },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "label_essweb_system_hourLabel"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                  model: {
                                    value:
                                      _vm.TransactionsData.number_of_minutes,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.TransactionsData,
                                        "number_of_minutes",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "TransactionsData.number_of_minutes",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          {
                            staticClass:
                              "white--text rounded-lg pa-3 subtitle-1",
                            attrs: { color: "primary" },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_leaveBalance_form_dialog_totalMinutesLabel"
                                  )
                                ) +
                                  ": " +
                                  _vm._s(
                                    _vm.$get_thousand_num(_vm.totalMinute)
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm.$t("label_essweb_system_minutesLabel")
                                  )
                              ),
                            ]),
                            _c("span"),
                          ]
                        ),
                      ],
                      1
                    ),
                    Number(_vm.clientMode) == 1
                      ? _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "6",
                              md: "6",
                              lg: "6",
                              cols: "12",
                            },
                          },
                          [
                            _c("DateTimePicker", {
                              attrs: {
                                type: "date",
                                readonly: !_vm.isEdited,
                                filled: false,
                                defaultTime:
                                  _vm.TransactionsData.effective_utc_datetime,
                                max: _vm.TransactionsData.expired_utc_datetime,
                                rules: _vm.$GetRules(
                                  ["_Require_Rules"],
                                  [null]
                                ),
                                label: _vm.$t(
                                  "label_essweb_leaveBalance_form_dialog_effectiveStartDateLabel"
                                ),
                              },
                              on: {
                                change: function (time) {
                                  return (_vm.TransactionsData.effective_utc_datetime =
                                    time)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    Number(_vm.clientMode) == 1
                      ? _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "6",
                              md: "6",
                              lg: "6",
                              cols: "12",
                            },
                          },
                          [
                            _c("DateTimePicker", {
                              attrs: {
                                type: "date",
                                readonly: !_vm.isEdited,
                                filled: false,
                                defaultTime:
                                  _vm.TransactionsData.expired_utc_datetime,
                                min: _vm.TransactionsData
                                  .effective_utc_datetime,
                                rules: _vm.$GetRules(
                                  ["_Require_Rules"],
                                  [null]
                                ),
                                label: _vm.$t(
                                  "label_essweb_leaveBalance_form_dialog_expiredDateLabel"
                                ),
                              },
                              on: {
                                change: function (time) {
                                  return (_vm.TransactionsData.expired_utc_datetime =
                                    time)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_leaveBalance_form_dialog_remarkLabel"
                              )
                            )
                          ),
                        ]),
                        _c("v-textarea", {
                          attrs: {
                            rows: "5",
                            "no-resize": "",
                            maxlength: "500",
                            dense: "",
                            counter: "500",
                            "single-line": "",
                            readonly: !_vm.isEdited,
                            filled: false,
                          },
                          model: {
                            value: _vm.TransactionsData.remarks,
                            callback: function ($$v) {
                              _vm.$set(_vm.TransactionsData, "remarks", $$v)
                            },
                            expression: "TransactionsData.remarks",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }